import { render, staticRenderFns } from "./My-pagination.vue?vue&type=template&id=95ef033e&scoped=true"
import script from "./My-pagination.vue?vue&type=script&lang=js"
export * from "./My-pagination.vue?vue&type=script&lang=js"
import style0 from "./My-pagination.vue?vue&type=style&index=0&id=95ef033e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef033e",
  null
  
)

export default component.exports